import { Row } from '../add-member-row';
import { Membership } from '../../models/member';

interface LicenseCalculation {
  validCount: number;
  newLicensesRequired: number;
  licensesToPurchase: number;
}

/**
 * Calculates license requirements for adding new members
 * @param members - Array of members (rows or existing members) to validate and count
 * @param availableLicenses - Number of available licenses
 * @param minimumLicensePurchase - Optional minimum number of licenses that must be purchased
 * @returns License calculation including valid count, required licenses, and licenses to purchase
 */
export default function calculateLicenseRequirements(
  members: (Row | Membership)[],
  availableLicenses: number,
  minimumLicensePurchase?: number,
): LicenseCalculation {
  const validMembers = members.filter(
    (m) => m.email && m.first_name && m.last_name && m.role_id && m.existing_user !== true,
  );

  const newLicensesRequired = Math.max(0, validMembers.length - availableLicenses);

  let licensesToPurchase = newLicensesRequired;

  if (newLicensesRequired > 0 && minimumLicensePurchase && newLicensesRequired < minimumLicensePurchase) {
    licensesToPurchase = minimumLicensePurchase;
  }

  return {
    validCount: validMembers.length,
    newLicensesRequired,
    licensesToPurchase,
  };
}
